module.exports = __webpack_public_path__ + "static/homepageBG4-06edd0cdd26769ec4e29bc4ab1defbbe.jpg";